import { Component, OnInit, ViewChild } from '@angular/core';
import { Suggestion } from '../Models/suggestion.modal';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { global } from '../../shared/global';
import { SuggestionService } from '../suggestion/suggestion.service';
import { Location } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-suggestion',
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.css']
})
export class SuggestionComponent implements OnInit {

  @ViewChild('suggestionForm', { static: true }) suggestionForm: NgForm;

  termConditionLink: any;
  data: Suggestion;
  responseData: any;

  constructor(private router: Router, private service: SuggestionService, private location: Location, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.termConditionLink = global.termConditionLink;
    this.data = new Suggestion();
  }

  onSubmit(suggestion: Suggestion) {
    if (this.suggestionForm.valid) {

      const formData = new FormData();
      formData.append("name", suggestion.name);
      formData.append("mobile_number", suggestion.mobile_number);
      formData.append("suggestion", suggestion.suggestion);
      formData.append("extra_info", suggestion.extra_info);

      this.spinner.show();
      this.service.insertSuggestion(formData)
        .subscribe(data => {
          this.responseData = data;
          if (this.responseData.status == false) {
            this.spinner.hide();
          }
          else {
            this.spinner.hide();
            // this.router.navigate(["/customer"]);
            this.backToPrevious();
          }
        });
    }
  }

  backToPrevious() {
    // this.location.back();
    // history.back();
    window.history.back();
  }
}
